/**
 * Jayant's whole app: four tiles, 1.25x type, one decision each, nothing nested
 * more than a level. No red unless something is genuinely wrong.
 *
 * Approve is deliberately two taps. Slow is fine here; wrong is not.
 */
export interface AdminTile {
  id: string
  label: string
  count: number
  verb: string
}

export interface AdminTilesProps {
  tiles: AdminTile[]
  /** The id mid-confirmation, which turns that tile's verb into a confirm step. */
  confirming?: string
}

export function AdminTiles({ tiles, confirming }: AdminTilesProps) {
  // Exactly one halo: the first tile with work waiting. A day with nothing to do
  // looks quiet, which is the honest signal.
  const attention = tiles.find((t) => t.count > 0)?.id ?? null

  return (
    <div className="admin-grid">
      {tiles.map((tile) => (
        <section key={tile.id} className={`admin-tile${tile.id === attention ? ' pulse-halo' : ''}`}>
          <span className="t-title">{tile.label}</span>
          <span className="count-tick t-display">{tile.count}</span>
          <button type="button" className="btn btn-primary">
            {confirming === tile.id ? 'Confirm' : tile.verb}
          </button>
        </section>
      ))}
    </div>
  )
}
